import { BaseModel } from '../base/base-model'
import { UpdateUserPublicDataModel } from './update/update-user-public-data'

/**
 * @memberof loavies.models.user
 * @constructor
 */

export class UserEditFormModel extends BaseModel {
  /**
   * @param {File} [avatar]
   * @param {File} [banner]
   * @param {string} [displayName]
   * @param {string} [bio]
   * @param {loavies.models.user.UpdateUserPublicDataModel} [publicData]
   */
  constructor({
    avatar,
    banner,
    displayName,
    bio,
    publicData,
  }) {
    super()

    /** @type {File} */
    if (!this.isUndefined(avatar)) this.avatar = avatar

    /** @type {File} */
    if (!this.isUndefined(banner)) this.banner = banner

    /** @type {string} */
    if (!this.isUndefined(displayName)) this.displayName = displayName

    /** @type {string} */
    if (!this.isUndefined(bio)) this.bio = bio

    /** @type {loavies.models.user.UpdateUserPublicDataModel} */
    if (!this.isUndefined(publicData)) this.publicData = new UpdateUserPublicDataModel(publicData)
  }
}
